import { useQuery } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useMainQueryKey } from './useMainQueryKey'

const document = graphql(`
  query DocumentReportEditPage_Main($documentReportId: ID!) {
    document(documentId: $documentReportId) {
      id
      content
      title
      updatedAt
    }
  }
`)

export const useMainQuery = () => {
  const graphQLRequest = useGraphQLRequest()
  const queryKey = useMainQueryKey()
  const [_, variables] = queryKey

  return useQuery({
    queryFn: async () => {
      const result = await graphQLRequest({ document, variables })

      return result.document ?? undefined
    },
    queryKey,
    gcTime: 0,
  })
}

export type DocumentReport = NonNullable<QueryResultOf<typeof useMainQuery>>
